import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getBaseUrl } from '@utils/general/getBaseUrl';
import { DIRECT_SALES_RETURN } from '@utils/constants/direct-sales-return/sales-return.constants';
import { baseQueryWithReauth } from '@states/auth/auth.api';

export const directSalesReturnApi = createApi({
    reducerPath: 'directSalesReturnApi',
    tagTypes: ['DirectSalesReturn'],
    baseQuery: baseQueryWithReauth,
    endpoints: (builder) => ({
        getAllDirectSaleReturns: builder.query<
            [],
            {
                page?: number;
                limit?: number;
                customer_first_name?: string;
                direct_sales_invoice_code?: string;
                direct_sales_return_code?: string;
            }
        >({
            query: ({
                page = 1,
                limit = 10,
                customer_first_name,
                direct_sales_invoice_code,
                direct_sales_return_code,
            }) => {
                const queryParams = {
                    url: DIRECT_SALES_RETURN.GET_ALL,
                    params: { page, limit },
                };

                if (customer_first_name) {
                    //@ts-ignore
                    queryParams.params.customer_first_name =
                        customer_first_name;
                }

                if (direct_sales_invoice_code) {
                    //@ts-ignore
                    queryParams.params.direct_sales_invoice_code =
                        direct_sales_invoice_code;
                }

                if (direct_sales_return_code) {
                    //@ts-ignore
                    queryParams.params.direct_sales_return_code =
                        direct_sales_return_code;
                }

                return queryParams;
            },
        }),
        getAllDirectMakePayments: builder.query<
            [],
            {
                page?: number;
                limit?: number;
                direct_sales_return_code?: string;
            }
        >({
            query: ({
                page = 1,
                limit = 10,

                direct_sales_return_code,
            }) => {
                const queryParams = {
                    url: DIRECT_SALES_RETURN.GET_ALL_MAKE_PAYMENTS,
                    params: { page, limit },
                };

                if (direct_sales_return_code) {
                    //@ts-ignore
                    queryParams.params.direct_sales_return_code =
                        direct_sales_return_code;
                }

                return queryParams;
            },
        }),
        getDirectSaleReturn: builder.query<
            any,
            { direct_sales_return_id: string | number }
        >({
            query: ({ direct_sales_return_id }) =>
                `${DIRECT_SALES_RETURN.GET_ONE}${direct_sales_return_id}`,
        }),
        createDirectSaleReturn: builder.mutation({
            query: (body) => ({
                url: DIRECT_SALES_RETURN.CREATE,
                method: 'POST',
                body,
            }),
        }),
        updateDirectSaleReturn: builder.mutation({
            query: ({ id, body }) => ({
                url: `${DIRECT_SALES_RETURN.UPDATE}${id}`,
                method: 'PATCH',
                body,
            }),
        }),
        createDirectMakePayment: builder.mutation({
            query: ({ direct_sales_return_id, body }) => ({
                url: `${DIRECT_SALES_RETURN.MAKE_PAYMENT}${direct_sales_return_id}`,
                method: 'PATCH',
                body,
            }),
        }),
        deleteDirectSaleReturn: builder.mutation({
            query: ({ id, body }) => ({
                url: `${DIRECT_SALES_RETURN.DELETE}${id}`,
                method: 'DELETE',
                body,
            }),
        }),
        deleteDirectMakePayment: builder.mutation({
            query: ({ direct_sales_return_payment_made_id, body }) => ({
                url: `${DIRECT_SALES_RETURN.DELETE_MAKE_PAYMENT}${direct_sales_return_payment_made_id}`,
                method: 'DELETE',
                body,
            }),
        }),
    }),
    keepUnusedDataFor:0
});

export const {
    useGetAllDirectSaleReturnsQuery,
    useGetDirectSaleReturnQuery,
    useCreateDirectSaleReturnMutation,
    useUpdateDirectSaleReturnMutation,
    useDeleteDirectSaleReturnMutation,
    useCreateDirectMakePaymentMutation,
    useGetAllDirectMakePaymentsQuery,
    useDeleteDirectMakePaymentMutation,
} = directSalesReturnApi;
